import React, { useEffect, useRef } from "react";
import { ReactComponent as KreskyPanelLogo } from "../assets/kresky-logo-info-red.svg";
import { ReactComponent as KreskyIllustration } from "../assets/kresky-ponadczasowy-styl.svg";
import { ReactComponent as KreskyUidoMark } from "../assets/kresky-uido-mark.svg";

const KreskyInfoBox = React.forwardRef(
  (
    {
      id,
      isOpen = false,
      className = "",
      nodeId = "3509:942",
    },
    ref
  ) => {
    const illustrationRef = useRef(null);
    const drawTimeoutRef = useRef(null);

    useEffect(() => {
      if (drawTimeoutRef.current) {
        window.clearTimeout(drawTimeoutRef.current);
        drawTimeoutRef.current = null;
      }

      const illustration = illustrationRef.current;
      if (!illustration) return undefined;

      const paths = Array.from(illustration.querySelectorAll("path"));
      paths.forEach((path) => {
        const length =
          typeof path.getTotalLength === "function" ? path.getTotalLength() : 0;
        if (!length) return;
        path.style.transition = "none";
        path.style.strokeDasharray = `${length}`;
        path.style.strokeDashoffset = `${length}`;
        path.dataset.drawAnimated = "0";
      });

      if (!isOpen) return undefined;

      drawTimeoutRef.current = window.setTimeout(() => {
        paths.forEach((path, index) => {
          const length =
            typeof path.getTotalLength === "function"
              ? path.getTotalLength()
              : 0;
          if (!length) return;

          path.style.transition = "none";
          path.style.strokeDasharray = `${length}`;
          path.style.strokeDashoffset = `${length}`;
          path.getBoundingClientRect();
          path.style.transition = `stroke-dashoffset 2.2s cubic-bezier(0.22, 1, 0.36, 1) ${
            index * 90
          }ms`;
          path.style.strokeDashoffset = "0";
          path.dataset.drawAnimated = "1";
        });
      }, 430);

      return () => {
        if (drawTimeoutRef.current) {
          window.clearTimeout(drawTimeoutRef.current);
          drawTimeoutRef.current = null;
        }
      };
    }, [isOpen]);

    return (
      <div
        id={id}
        ref={ref}
        className={`kresky-info-box${isOpen ? " is-open" : ""}${
          className ? ` ${className}` : ""
        }`}
        data-node-id={nodeId}
        data-name="opis_kresky_infobox"
        aria-hidden={!isOpen}
      >
        <div className="kresky-info-box__content" data-node-id="3509:943">
          <div className="kresky-info-box__visual" data-node-id="3509:944">
            <div
              className="kresky-info-box__logo-wrap"
              data-node-id="3509:945"
            >
              <KreskyPanelLogo
                className="kresky-info-box__logo"
                aria-hidden="true"
                data-node-id="3509:946"
              />
            </div>
            <div
              className="kresky-info-box__illustration"
              data-node-id="3509:947"
            >
              <KreskyIllustration ref={illustrationRef} aria-hidden="true" />
            </div>
          </div>
          <div className="kresky-info-box__text" data-node-id="3509:949">
            <p className="kresky-info-box__body" data-node-id="3509:950">
              To ponadczasowy styl
              <br />
              jedną linią, fineline.
              <br />
              Dedykowany wektor
              <br className="kresky-info-box__desktop-break" />
              pozytywnych doświadczeń.
            </p>
          </div>
        </div>
        <KreskyUidoMark
          className="kresky-info-box__mark"
          aria-hidden="true"
          data-node-id="3509:954"
        />
      </div>
    );
  }
);

KreskyInfoBox.displayName = "KreskyInfoBox";

export default KreskyInfoBox;
